import { InstructionsKey } from '../../models/question';
import { InstructionComponent } from '../../models/instructions';
import React from 'react';
import Cap from './../../components/shared/Cap';
import LinkButton from '../../components/shared/LinkButton';

export class A implements InstructionComponent {
  getInstructionKey = () => InstructionsKey.A;
  isEnable = () => true;
  getIconSrc = () => '/rpo/svg/Policeman.svg';
  getTitle = () => 'ZGŁOŚ PRZESTĘPSTWO NA POLICJĘ';
  getContent = () => (
    <>
      <p>
        <Cap>telefonicznie</Cap> Jeśli zagrożone jest życie lub zdrowie – Twoje lub osoby, której pomagasz – zadzwoń pod
        numer alarmowy 112. Możesz zostać poproszony o zgłoszenie się do najbliższego komisariatu, aby złożyć
        zawiadomienie osobiście.
      </p>
      <p>
        <Cap>online</Cap> Jeśli jest zagrożone życie lub zdrowie, a chcesz dokonać zgłoszenia przez komputer - wypełnij
        formularz Biura do Walki z Cyberprzestępczością Komendy Głównej Policji. Zgłoszenia monitorowane są przez całą
        dobę, a w przypadku zagrożenia życia policja ma obowiązek podjąć działania niezwłocznie. Warto wkleić link, aby
        ułatwić funkcjonariuszom dotarcie do osoby zagrożonej. Dyżurny zabezpieczy też treść. Nie musisz podawać swojego
        imienia i nazwiska. Jeśli jest to ktoś, kogo znasz – każda informacja dotycząca miejsca, w którym ta osoba się
        znajduje, będzie pomocna. Warto napisać, czy to co oglądasz dzieje się w danej chwili. Dostaniesz automatyczne
        potwierdzenie zgłoszenia.
        <br></br>
        <LinkButton link='http://policja.pl/pol/form/dodaj153,Formularz-kontaktowy-Cyberprzestepczosc.html'>
          Formularz kontaktowy online
        </LinkButton>
      </p>
      <p>
        <Cap>Mail</Cap> Możesz też zgłosić przestępstwo mailem na adres mailowy komendy (
        <LinkButton link='http://www.info.policja.pl/inf/jednostki/47301,dok.html'>
          Strony internetowe komend wojewódzkich
        </LinkButton>
        ). Nie zawsze otrzymasz odpowiedź z komendy, jednak Twoje zgłoszenie zostanie przyjęte i będzie rozpatrzone.
      </p>
      <p>
        Napisz na przykład:
        <ul>
          <li> Natrafiłem w internecie na film, w którym mężczyzna bije dziecko (link). Proszę o zajęcie się tym </li>
          <li> Kolega napisał, że myśli o samobójstwie (link, ewentualnie dane kolegi i adres)</li>
          <li> Nieznajoma osoba grozi mi śmiercią w komentarzu pod moim postem (link)</li>
        </ul>
      </p>
      <LinkButton link='http://www.info.policja.pl/inf/jednostki/47301,dok.html'>Znajdź komendę wojewódzką</LinkButton>
      <br></br>
      <p>
        <Cap>osobiście</Cap> Możesz też zgłosić się osobiście do najbliższej jednostki policji. Otrzymasz wtedy pisemne
        potwierdzenie zawiadomienia o popełnieniu przestępstwa. W przypadku takiego rozwiązania, musisz liczyć się z
        koniecznością czekania w kolejce.
      </p>
    </>
  );
}
